/**
* API环境配置
* 说明：此模块依赖构建中参数process.env.API_DOMAIN，process.env.ADDRESS
*/
// 为了兼容ssjlicai.com, feidee.com等多域名，需要取到当前页面访问地址的一级域名
import url from '@common/url'

let hostname = url('domain')
let domains = {}

if (process.env.API_DOMAIN === 'prod') {
  domains = {
    res: `https://marketres.${hostname}`,
    api: `https://moneymarket.${hostname}`,
    actapi: `https://act.${hostname}`,
    mkt: `https://moneymarket.${hostname}`,
    pc: `https://8.${hostname}`,
    collect: `https://dataapi.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'uat') {
  domains = {
    res: `https://lcuatres.${hostname}`,
    api: `https://lcuat.${hostname}`,
    actapi: `https://actuat.${hostname}`,
    mkt: `https://lcuat.${hostname}`,
    pc: `https://lcuatweb.${hostname}/market-mobi`,
    collect: `https://dataapi.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'test6') {
  domains = {
    res: `https://lctsres6.${hostname}`,
    api: `https://lcts6.${hostname}`,
    actapi: `https://act6.${hostname}`,
    mkt: `https://lcts6.${hostname}`,
    pc: `https://lcts6.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`, // 测试环境数据上报都在test5上
  }
} else if (process.env.API_DOMAIN === 'test5') {
  domains = {
    res: `https://lctsres5.${hostname}`,
    api: `https://lcts5.${hostname}`,
    actapi: `https://act5.${hostname}`,
    mkt: `https://lcts5.${hostname}`,
    pc: `https://lcts5.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'test4') {
  domains = {
    res: `https://lctsres4.${hostname}`,
    api: `https://lcts4.${hostname}`,
    actapi: `https://act4.${hostname}`,
    mkt: `https://lcts4.${hostname}`,
    pc: `https://lcts4.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'test3') {
  domains = {
    res: `https://lctsres3.${hostname}`,
    api: `https://lcts3.${hostname}`,
    actapi: `https://act3.${hostname}`,
    mkt: `https://lcts3.${hostname}`,
    pc: `https://lcts3.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'test2') {
  domains = {
    res: `https://lctsres2.${hostname}`,
    api: `https://lcts2.${hostname}`,
    actapi: `https://act2.${hostname}`,
    mkt: `https://lcts2.${hostname}`,
    pc: `https://lcts2.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'test1') {
  domains = {
    res: `https://lctsres1.${hostname}`,
    api: `https://lcts1.${hostname}`,
    actapi: `https://act1.${hostname}`,
    mkt: `https://lcts1.${hostname}`,
    pc: `https://lcts1.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'testdev') {
  domains = {
    res: `http://devpub.${hostname}`,
    api: `http://devpub.${hostname}`,
    actapi: `http://act.${hostname}`,
    mkt: `http://devpub.${hostname}`,
    pc: `http://devpcweb.${hostname}/p2pmarket`,
    collect: `https://lcts5.${hostname}`,
  }
} else if (process.env.API_DOMAIN === 'dev') {
  domains = {
    res: `http://${process.env.ADDRESS}`,
    api: 'http://172.22.23.214:8090',
    actapi: 'http://172.22.23.214:8090',
    mkt: `http://${process.env.ADDRESS}`,
    pc: `https://8.${hostname}`,
    collect: `http://${process.env.ADDRESS}:8090`,
  }
} else if (process.env.API_DOMAIN === 'mock') {
  domains = {
    res: `http://${process.env.ADDRESS}`,
    api: `http://${process.env.ADDRESS}:8090`,
    actapi: `http://${process.env.ADDRESS}:8090`,
    mkt: `http://${process.env.ADDRESS}`,
    pc: `https://8.${hostname}`,
    collect: `http://${process.env.ADDRESS}:8090`,
  }
} else {
  domains = {
    res: '',
    api: '',
    actapi: '',
    mkt: '',
    pc: ''
  }
}

// 自定义hostname
export const setHostName = (host) => {
  Object.keys(domains).forEach((name) => {
    domains[name] = domains[name].replace(hostname, host)
  })
  hostname = host
}

// 设置所有的hostname
export const setAllHostName = (hostMap) => {
  Object.keys(domains).forEach((name) => {
    domains[name] = hostMap[name]
  })

  return domains
}

export default domains



// WEBPACK FOOTER //
// ./node_modules/@finance/login/node_modules/@common/domain/src/index.js